import React, {Fragment, useEffect, useMemo, useState} from 'react';
import {Link} from 'react-router-dom';
import {Menu, Grid, Radio} from 'antd';
import IntlMessage from '../util-components/IntlMessage';
import Icon from '../util-components/Icon';
import navigationConfig, {getNavItemFromkey, simpleNavigationConfig} from 'configs/NavigationConfig';
import {useSelector, useDispatch} from 'react-redux';
import {SIDE_NAV_LIGHT, NAV_TYPE_SIDE} from "constants/ThemeConstant";
import utils from 'utils'
import {onMobileNavToggle} from 'store/slices/themeSlice';
import {checkForfait, getConfig, getForfaits, setConfigs} from "../permissions/functions";
import {ENV} from "../../configs/AppConfig";
import ApiService from "../../services/ApiService";

const {useBreakpoint} = Grid;

const setLocale = (localeKey, isLocaleOn = true) =>
    isLocaleOn ? <IntlMessage id={localeKey}/> : localeKey.toString();

const setDefaultOpen = (key) => {
    let keyList = [];
    let keyString = "";
    if (key) {
        const arr = key.split("-");
        for (let index = 0; index < arr.length; index++) {
            const elm = arr[index];
            index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
            keyList.push(keyString);
        }
    }
    return keyList;
};

const MenuItem = ({title, icon, path}) => {

    const dispatch = useDispatch();

    const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg');

    const closeMobileNav = () => {
        if (isMobile) {
            dispatch(onMobileNavToggle(false))
        }
    }

    return (
        <>
            {icon && <Icon type={icon}/>}
            <span style={{color:"#ececec"}}> {setLocale(title)}</span>
            {path && <Link onClick={closeMobileNav} to={path}/>}
        </>
    )
}

const getSideNavMenuItem = (navItem) => navItem.map(nav => {

    if(nav.type==="divider"){
        return nav
    }

    return {
        key: nav.key,
        label: <MenuItem title={nav.title} {...(nav.isGroupTitle ? {} : {path: nav.path, icon: nav.icon})} />,
        ...(nav.isGroupTitle ? {type: 'group'} : {}),
        ...(nav.submenu.length > 0 ? {children: getSideNavMenuItem(nav.submenu)} : {})
    }
})

const getTopNavMenuItem = (navItem) => navItem.map(nav => {
    if(nav.type==="divider"){
        return nav
    }

    return {
        key: nav.key,
        label: <MenuItem title={nav.title} icon={nav.icon} {...(nav.isGroupTitle ? {} : {path: nav.path})} />,
        ...(nav.submenu.length > 0 ? {children: getTopNavMenuItem(nav.submenu)} : {})
    }
})

const SideNavContent = (props) => {

    //console.log("menuComplet",props.access.menuComplet)

    const [menuComplet, setMenuComplet] = useState(props.access.type!=="ADMIN"?true:(props.access.menuComplet ?? true))

    const {routeInfo, hideGroupTitle} = props;

    const sideNavTheme = useSelector(state => state.theme.sideNavTheme);
    const navCollapsed = useSelector(state => state.theme.navCollapsed)


    const menuItems = getSideNavMenuItem(menuComplet?props.navigation:props.simpleNavigation)

    var [openKeys, setOpenKeys] = useState(setDefaultOpen(routeInfo?.key))

    //console.log(routeInfo,routeInfo?.key,setDefaultOpen(routeInfo?.key))

    const onChangeSimpleMenu=async (bool)=>{
        setMenuComplet(bool)
        const res=await ApiService.post("/access/config", {menuComplet:bool})
        console.log(res)
    }

    return (
        <Fragment>

            {props.access.type==="ADMIN" && !navCollapsed && (
                <div style={{padding: "20px",minWidth:"100%"}}>
                    <Radio.Group buttonStyle={"solid"} value={menuComplet} size={"small"}
                                 onChange={(e) => onChangeSimpleMenu(e.target.value)}>
                        <Radio.Button value={false}>Menu Simple</Radio.Button>
                        <Radio.Button value={true}>Menu Avancé</Radio.Button>
                    </Radio.Group>
                </div>
            )}

            {navCollapsed &&(
                <div style={{height:40}}/>
            )}


            <Menu
                mode="inline"
                theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
                style={{borderRight: 0}}
                defaultSelectedKeys={openKeys}
                defaultOpenKeys={openKeys}
                className={hideGroupTitle ? "hide-group-title" : ""}
                items={menuItems}
                openKeys={openKeys}
                onOpenChange={(keys) => {
                    const key = keys[keys.length - 1]
                    setOpenKeys([key])
                }}
            />
        </Fragment>
    );
};

const TopNavContent = (props) => {

    const topNavColor = useSelector(state => state.theme.topNavColor);

    const menuItems = useMemo(() => getTopNavMenuItem(props.navigation), [])

    return (
        <Menu
            mode="horizontal"
            style={{backgroundColor: topNavColor}}
            items={menuItems}
        />
    );
};


const getFinalNavData = (access, menu) => {
    const isAccessMenu = !!access.menu

    let data = []

    for (var nav of menu) {

        if(nav.type==="divider"){
            data.push(nav)
            continue
        }

        if (isAccessMenu) {
            if (nav.hidden) {
                console.log("HIDDEN", nav.key)
                continue
            }
            nav = {...getNavItemFromkey(nav.key), ...nav}
        }
        if (!nav.title) {
            //console.log(getNavItemFromkey(nav.key))
            continue
        }

        if (ENV === "PROD" && nav.dev) {
            continue
        }

        var finalSubmenu = []
        const submenu = nav.children || nav.submenu
        if (Array.isArray(submenu) && submenu.length > 0) {
            finalSubmenu = getFinalNavData(access, submenu)
        }

        if (finalSubmenu.length > 0) {
            nav.submenu = finalSubmenu
        } else {
            nav.submenu = []
        }

        if (Array.isArray(nav.forfaits) && nav.forfaits.length > 0) {
            if (checkForfait(nav.forfaits)) {
                data.push(nav)
            }
        } else if (Array.isArray(nav.noForfaits) && nav.noForfaits.length > 0) {
            if (!getForfaits().some(i=>nav.noForfaits.includes(i))){
                data.push(nav)
            }
        } else {
            data.push(nav)
        }

    }

    return data
}

const getFinalNav = (access, org,simple=false) => {
    if (!org) {
        return []
    }

    let menu = access.menu || [...navigationConfig]

    if(simple){
        menu=[...simpleNavigationConfig]
    }

    console.log("MENU", menu)

    return getFinalNavData(access, menu)
}

const MenuContent = (props) => {

    const org = useSelector(state => state.auth.org)
    const configs = useSelector(state => state.auth.configs)
    const access = useSelector(state => state.auth.access)


    const getNavPermission = (navData) => {
        if (!org) {
            return []
        }

        if (access.type == "ADMIN" || access.permissions.includes("all")) {
            return navData
        }

        var data = []
        for (var nav of navData) {
            if (nav.permission) {
                if (access.permissions.find(i => i == nav.permission)) {
                    data.push(nav)
                }
            }
        }

        return data
    }

    return props.type === NAV_TYPE_SIDE ? (
        <SideNavContent {...props} access={access} simpleNavigation={getNavPermission(getFinalNav(access, org,true))} navigation={getNavPermission(getFinalNav(access, org))}/>
    ) : (
        <TopNavContent {...props} access={access} simpleNavigation={getNavPermission(getFinalNav(access, org,true))} navigation={getNavPermission(getFinalNav(access, org))}/>
    );
};

export default MenuContent;
